import { useEffect, useState } from 'react';

const FALLBACK_TRIAL_DAYS = 14;

// Public marketing copy pulls the trial length from Stripe's own Price config (via
// api/trial-days.js) rather than a hardcoded string -- see api/create-checkout-session.js's
// trial_from_plan for the actual checkout-side counterpart of this. Starts at the current
// real-world default so the very first render already shows correct copy with no loading
// flicker, then silently updates only in the rare case the fetched value differs (i.e. right
// after someone changes it in the Stripe Dashboard). api/trial-days.js's own Cache-Control
// header (not a client-side cache here) is what keeps this from hitting Stripe on every load.
export function useTrialDays() {
  const [trialDays, setTrialDays] = useState(FALLBACK_TRIAL_DAYS);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/trial-days')
      .then(res => res.json())
      .then(data => { if (!cancelled && data?.trialDays) setTrialDays(data.trialDays); })
      .catch(() => {}); // Fails silently -- FALLBACK_TRIAL_DAYS is already showing.
    return () => { cancelled = true; };
  }, []);

  return trialDays;
}
